<div class="order-at" [ngClass]="{ 'order-at--visible': show }">
  <span class="order-at__remove" (click)="show = false">✕</span>

  <a href="http://orderatphl.com/" target="_BLANK" rel="nofollow" (click)="clickEvent();">
    <img src="/assets/images/mphl-orderAt-stickyCTA-orderPickup.png" alt="">
  </a>
</div>
